import React, { useState } from 'react';
import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { useController } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import styles from '../ForceAccountsBlock/styles';
import CloseIcon from 'assets/images/close-icon.svg';
import cn from 'classnames';

const PtoAccountBlock = ({ classes, pageType, control, errors }) => {

  const {
    field: { onChange, value: ptoValues },
  } = useController({
    name: 'PTOAdminEmail',
    control,
  });

  const [isShowEmailsPTO, setShowEmailsPTO] = useState(false);


  const handleEmailChange = (i) => (e) => {
    const { value } = e.target;
    const nextValue = ptoValues.map((t, index) => (index === i ? value : t));
    onChange(nextValue);
  };
  const handleEmailRemoving = (i) => () => {
    const nextValue = ptoValues.filter((_, index) => index !== i);
    onChange(nextValue);
  };

  const handleAddEmail = () => {
    setShowEmailsPTO(true);
    onChange([...ptoValues.filter((v) => v.length), '']);
  };

  return (
    <div>
      <div className={classes.actionsWrapper}>
        {!!ptoValues?.length &&
          ptoValues.slice(0, isShowEmailsPTO ? ptoValues.length : 3).map((email, index) => (
            <Grid container spacing={2} key={`PTOAdminEmail-${index}`} alignItems="center">
              <Grid item xs={10} sm={6} md={4} className={classes.zeroPaddingTop}>
                {index === 0 && (
                  <Typography
                    variant="body1"
                    color="textSecondary"
                    className={classes.regularFontWeight}
                  >
                    Email:
                  </Typography>
                )}
                <TextField
                  id={`PTOAdminEmail[${index}]`}
                  name={`PTOAdminEmail[${index}]`}
                  type="email"
                  value={email}
                  className={classes.textField}
                  onChange={handleEmailChange(index)}
                  variant="outlined"
                  inputProps={{ 'aria-label': 'PTO Admin Email' }}
                  fullWidth
                  disabled={pageType === 'read'}
                />
              </Grid>
              {pageType === 'edit' && (
                <span
                  className={classes.removeEmail}
                  onClick={handleEmailRemoving(index)}
                  style={index === 0 ? { marginTop: 15 } : {}}
                >
                  <img src={CloseIcon} alt="delete" />
                </span>
              )}
            </Grid>
          ))}
        {ptoValues?.length > 3 && (
          <div
            className={classes.buttonWrapper}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowEmailsPTO((prev) => !prev);
            }}
          >
            <div className={classes.nonActionsIcon}>
              <ExpandMoreIcon className={cn(isShowEmailsPTO ? '' : classes.reversIcon)} />
            </div>
            <p className={classes.textIconMore}>{`${
              isShowEmailsPTO ? 'Hide' : 'Show'
            } additional email addresses`}</p>
          </div>
        )}
        {pageType === 'edit' && (
          <Button
            variant="text"
            className={classes.primaryTextButton}
            onClick={handleAddEmail}
            disableRipple
          >
            + Add Email
          </Button>
        )}
      </div>
    </div>
  );
};

PtoAccountBlock.propTypes = {
  classes: propTypes.object.isRequired,
  pageType: propTypes.string.isRequired,
  errors: propTypes.object.isRequired,
  control: propTypes.object.isRequired,
};

export default withStyles(styles)(PtoAccountBlock);
